// Depends
import { group, subGroup, route, meta } from '@/helpers/routes'

import Profile from './profile/me'
import { routes as covenants } from './covenants'
import { routes as dependents } from './dependents'
import { routes as addresses } from './addresses'

const profileRoutes = [
  route('me', '/me', Profile, meta('Meu Perfil', true, 'guest'))
]

export default [
  ...group('/app/settings', [
    ...subGroup('/profile', profileRoutes),
    ...subGroup('/covenants', covenants),
    ...subGroup('/dependents', dependents),
    ...subGroup('/addresses', addresses)
  ])
]



// WEBPACK FOOTER //
// ./src/app/settings/routes.js